import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { getAuth } from "firebase/auth";
import QuoteForm from "../components/QuoteForm";
import QuotePreview from "../components/QuotePreview";
import QuoteContent from "../components/QuoteContent";

const QuoteBuilder = () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const [isAdmin, setIsAdmin] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [expandedQuoteId, setExpandedQuoteId] = useState(null);
  const [editingQuoteId, setEditingQuoteId] = useState(null);
  const [showNewQuoteModal, setShowNewQuoteModal] = useState(false);
  const [formData, setFormData] = useState({
    propertyName: "",
    management: "",
    managementAddress: "",
    projectTitle: "",
    description: "",
    total: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    additionalNotes: "",
    submittedBy: "",
    paymentTerms: "",
    fullPaymentTerms: "",
    warrantyType: "",
    fullWarranty: "",
  });

  useEffect(() => {
    user?.getIdTokenResult().then(token => {
      setIsAdmin(token?.claims?.admin === true);
    });
  }, [user]);

  useEffect(() => {
    const fetchQuotes = async () => {
      const snapshot = await getDocs(collection(db, "quotes"));
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setQuotes(data);
    };
    fetchQuotes();
  }, []);

  return (
    <div>
      <h2>📄 Quotes</h2>
      <button onClick={() => setShowNewQuoteModal(true)}>➕ New Quote</button>
      <ul>
        {quotes.map((quote) => (
          <li key={quote.id} style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span
                onClick={() => setExpandedQuoteId(prev => prev === quote.id ? null : quote.id)}
                style={{ cursor: "pointer" }}
              >
                {quote.projectTitle} – ${quote.total || "N/A"}
              </span>
              <button onClick={() => setEditingQuoteId(quote.id)}>Edit</button>
              <button
                onClick={async () => {
                  if (window.confirm("Delete this quote?")) {
                    await deleteDoc(doc(db, "quotes", quote.id));
                    setQuotes(prev => prev.filter(q => q.id !== quote.id));
                  }
                }}
                style={{ color: "red" }}
              >
                Delete
              </button>
              <button
                onClick={async () => {
                  await updateDoc(doc(db, "quotes", quote.id), { status: "approved" });
                  alert("Quote marked as Approved");
                }}
                style={{ backgroundColor: "green", color: "white" }}
              >
                Approve
              </button>
              <button
                onClick={async () => {
                  await updateDoc(doc(db, "quotes", quote.id), { status: "denied" });
                  alert("Quote marked as Denied");
                }}
                style={{ backgroundColor: "goldenrod", color: "black" }}
              >
                Deny
              </button>
            </div>

            {expandedQuoteId === quote.id && (
              <QuotePreview quote={quote} />
            )}

            {editingQuoteId === quote.id && (
              <QuoteForm
                existingQuote={quote}
                onFinish={() => {
                  setEditingQuoteId(null);
                  setExpandedQuoteId(null);
                  window.location.reload();
                }}
                onCancel={() => setEditingQuoteId(null)}
              />
            )}
          </li>
        ))}
      </ul>

      <hr />

      {selectedQuote ? (
        <>
          <QuoteForm
            onFinish={() => {
              setShowNewQuoteModal(false);
              window.location.reload();
            }}
            onCancel={() => setShowNewQuoteModal(false)}
          />
          <QuotePreview quote={formData} />
        </>
      ) : (
        <QuoteForm
          onFinish={() => window.location.reload()}
          onCancel={() => setSelectedQuote(null)}
        />
      )}

      {showNewQuoteModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "800px",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)"
            }}
          >
            <h3>Create New Quote</h3>
            <QuoteForm
              formData={formData}
              setFormData={setFormData}
              onFinish={() => {
                setShowNewQuoteModal(false);
                window.location.reload();
              }}
              onCancel={() => setShowNewQuoteModal(false)}
            />
            <QuotePreview quote={formData} />
          </div>
        </div>
      )}
    </div>
  );
};

export default QuoteBuilder;
